// Loader.js
import React from 'react';

const Loader = () => {
    return (
        <div className="loading">
            <div className='uil-ring-css' >
                <div></div>
            </div>
        </div>
    );
};

export default Loader;
